import { FunctionComponent } from "react";

/**
 * The one-line strip a cancelled company sees above its inbox during the read-only grace
 * month (PREC-3900).
 */
export const ReadOnlyPlanBanner: FunctionComponent<{ readOnlyUntil: string | null }> = ({
	readOnlyUntil,
}) => {
	const until = readOnlyUntil
		? new Intl.DateTimeFormat("en-GB", {
				day: "numeric",
				month: "long",
				year: "numeric",
				timeZone: "UTC",
			}).format(new Date(readOnlyUntil))
		: null;

	return (
		<div className="w-full bg-background-warning text-sm px-4 py-2">
			Your subscription has ended — you can read and export your data
			{until ? ` until ${until}` : ""}, but you cannot send messages.
		</div>
	);
};
